import { setAppIsEmptyOrg } from 'app-store';
import { AppEvents } from 'common-events';
import { loadApplications } from '../../applications/actions/applications-actions';
import { loadArtifacts } from '../../artifacts/actions/artifacts-actions';
import { loadInventory } from '../../dashboard-inventory/actions/inventory-actions';
import { loadDashboardInfo } from '../../dashboard/actions/dashboard-actions';
import { fetchIssuesTrend } from '../../dashboard/actions/issues-graph-actions';
import {
  invalidateIssuesCachedQueries,
  loadIssues,
} from '../../issues/active-issues/actions/active-issues-actions';
import { loadSbomLibraries } from '../../sbom/actions/sbom-libraries-actions';
import { loadSupplyChain } from '../../supply-chain/actions/supply-chain-actions';

export const setupAppListeners = () => {
  document.addEventListener(AppEvents.Scan.ScanEnd, () => {
    setAppIsEmptyOrg(false);
    refetchOrgData();
  });
};
export const refetchOrgData = () => {
  invalidateIssuesCachedQueries();
  return Promise.all([
    loadDashboardInfo(),
    loadInventory(),
    fetchIssuesTrend(),
    loadApplications({ update: true, cache: false }),
    loadIssues({ update: true, cache: false }),
    loadSupplyChain(),
    loadSbomLibraries({ update: true, cache: false }),
    loadArtifacts({ isLoadMoreItems: false, cache: false }),
  ]);
};
